
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '입회비는 정말 100% 반환되나요?',
      answer: '네, 5년 만기 후 입회비 전액을 반환해 드립니다. 스마트스코어는 중소기업 기업부 예비 유니콘으로 선정된 안정적인 기업으로, NH투자증권 PE, 산업은행 등 검증된 투자자들이 참여하고 있어 안심하고 이용하실 수 있습니다.'
    },
    {
      question: '연회비 5년간 면제 혜택은 누구에게 적용되나요?',
      answer: '현재 진행 중인 동계 프로모션 기간에 가입하시는 모든 회원님께 적용됩니다. 선착순 50구좌 한정이며, 상품에 따라 최대 5,000만원의 혜택을 받으실 수 있습니다.'
    },
    {
      question: '무기명 멤버십은 어떻게 사용하나요?',
      answer: '무기명 멤버십은 본인 외에도 가족, 지인, 비즈니스 파트너 등 누구나 사용할 수 있습니다. 법인 상품의 경우 4인 무기명으로 제공되어 접대나 임직원 복지용으로 활용하기에 최적입니다.'
    },
    {
      question: '전국 420여 개 골프장은 어디서 확인할 수 있나요?',
      answer: '상담 신청 시 전국 제휴 골프장 리스트와 상세 정보를 제공해 드립니다. 수도권, 제주를 포함한 전국 명문 골프장들이 포함되어 있으며, 해외 골프장도 이용 가능합니다.'
    },
    {
      question: '예약은 어떻게 하나요?',
      answer: '1:1 전담 컨시어지를 통해 예약하실 수 있습니다. 스마트스코어의 독보적 IT 기술력과 전문 상담사를 통해 95% 이상의 예약 성공률을 보장하며, 원하시는 날짜와 시간에 맞춰 최적의 골프장을 추천해 드립니다.'
    },
    {
      question: '그린피 할인은 어떻게 적용되나요?',
      answer: '상품에 따라 그린피 50% 할인 또는 100% 무료 혜택이 제공됩니다. 프리미엄 상품의 경우 그린피 전액이 무료이며, 일반 상품은 4인 기준 그린피의 50%를 할인받으실 수 있습니다.'
    }
  ];

  return (
    <section id="faq" className="py-14 md:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-gray-900 mb-3 md:mb-4">
            자주 묻는 질문
          </h2>
          <p className="text-sm sm:text-base md:text-xl text-gray-600">
            궁금하신 내용을 확인해보세요
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border-2 border-gray-200 rounded-xl overflow-hidden transition-all hover:border-blue-500"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-4 md:px-6 py-4 md:py-5 text-left flex justify-between items-center cursor-pointer"
              >
                <span className="text-sm sm:text-base md:text-lg font-semibold text-gray-900 pr-3">
                  {faq.question}
                </span>
                <i className={`ri-arrow-down-s-line text-xl md:text-2xl text-blue-600 transition-transform flex-shrink-0 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}></i>
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}>
                <div className="px-4 md:px-6 pb-4 md:pb-5 text-xs sm:text-sm md:text-base text-gray-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-12 text-center">
          <p className="text-sm md:text-base text-gray-600 mb-3 md:mb-4">더 궁금하신 사항이 있으신가요?</p>
          <a
            href="#signup"
            className="inline-block bg-blue-600 text-white px-6 md:px-8 py-2.5 md:py-3 rounded-full text-sm md:text-base font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            전문가와 상담하기
          </a>
        </div>
      </div>
    </section>
  );
}
